export default "__VITE_ASSET__49f95751__"